import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import { CarTile } from "@perxis-auto/ui-kit/lib/components/CarTile";
const TileImage = memo(function TileImage2({ isLoading = false, ...props }) {
  if (isLoading) {
    return /* @__PURE__ */ jsx(CarTile.ImageSkeleton, {});
  }
  return /* @__PURE__ */ jsx(CarTile.Image, { ...props });
});
export {
  TileImage
};
